import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { toast } from "sonner";
import { extendTailwindMerge } from "tailwind-merge";

// Register the custom type and weight utilities declared in the theme
// (styles/globals.css and apps/app app-globals.css) so tailwind-merge does not
// misclassify them: an unknown `text-*` reads as a colour and gets dropped next
// to `text-foreground`; an unknown `font-*` reads as a family.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-xxs",
        "text-title",
        "text-h1",
        "text-h2",
        "text-h3",
        "text-h4",
        "text-body",
        "text-cell",
        "text-nav",
        "text-meta",
        "text-badge",
        "text-doc-h1",
        "text-doc-h2",
        "text-doc-h3",
        "text-display",
        "text-display-lg",
        "text-hero",
        "text-overlay",
      ],
      "font-weight": ["font-selected"],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const handleError = (error: Error): void => {
  const message = error.message;

  toast.error(message);
};

export function formatBytes(
  bytes: number,
  opts: {
    decimals?: number;
    sizeType?: "accurate" | "normal";
  } = {}
) {
  const { decimals = 0, sizeType = "normal" } = opts;

  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const accurateSizes = ["Bytes", "KiB", "MiB", "GiB", "TiB"];
  if (bytes === 0) return "0 Byte";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / 1024 ** i).toFixed(decimals)} ${sizeType === "accurate" ? (accurateSizes[i] ?? "Bytes") : (sizes[i] ?? "Bytes")}`;
}
